import React from 'react';
import Box from '@mui/material/Box';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import colors from 'styles/colors';
import { avatarStyles } from 'utils/nameColorPicker';
import useGetUserData from 'hooks/useGetUserData';
import styles from './userHome.styles';

const UserProfile = () => {
  const { firstName, lastName, avatar: avatarUrl } = useGetUserData();

  return (
    <Box sx={{ display: 'flex', width: '100%' }}>
      <Avatar
        alt={`${firstName || 'avatar'} ${lastName || ''}`}
        src={avatarUrl}
        sx={avatarStyles(firstName, lastName)}
      >
        {firstName[0]}
      </Avatar>
      <Box>
        <Typography sx={{ ...styles.welcomeText, color: colors.text.primary }}>
          Welcome back
          {' '}
          {firstName}
          ! 👋
        </Typography>
        <Typography variant="subtitle2" color={colors.text.secondary}>
          Let’s try something new together.
        </Typography>
      </Box>

    </Box>
  );
};

export default UserProfile;
